"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderItemAttributesSchema = exports.OrderItemStatuses = void 0;
const zod_1 = require("zod");
const common_1 = require("../../helpers/common");
exports.OrderItemStatuses = {
    CREATED: 'created',
    PROCESSING_FOR_OUTBOUND: 'processing_for_outbound',
    TRASIT_FOR_OUTBOUND_RENT: 'transit_for_outbound_rent',
    RENT_IN_PROGRESS: 'rent_in_progress',
    TRANSIT_FOR_INBOUND: 'transit_for_inbound',
    PROCESSING_FOR_INBOUND: 'processing_for_inbound',
};
exports.OrderItemAttributesSchema = zod_1.z.object({
    id: zod_1.z.number(),
    status: zod_1.z.nativeEnum(exports.OrderItemStatuses),
    orderId: zod_1.z.number(),
    ownerType: zod_1.z.string(),
    ownerId: zod_1.z.number(),
    assetId: zod_1.z.number().nullable().optional(),
    couponId: zod_1.z.number().nullable().optional(),
    startsAt: (0, common_1.zodDateString)(true),
    endsAt: (0, common_1.zodDateString)(true),
    price: zod_1.z.number(),
});
//# sourceMappingURL=order_item.js.map